import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/apps/blogtostart/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager" */ "/root/apps/blogtostart/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["LoginForm"] */ "/root/apps/blogtostart/src/app/(auth)/auth-forms.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["T"] */ "/root/apps/blogtostart/src/components/i18n-ui/provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BreadcrumbNav","PaginationView"] */ "/root/apps/blogtostart/src/components/ui/i18n-parts.tsx");
